<script>
    import Route, {router} from "./lib/Router/Router.svelte";
    import R from "./lib/js/requests";
    import app from './lib/stores/app.js';
    import department$ from "./lib/stores/department$.js";
    import location$ from "./lib/stores/location$.js";
    import {copyObject, getDepartmentCode} from "./lib/js/utils.js";
    import PageLoader from "./lib/components/PageLoader.svelte";
    import PopupLoader from "./lib/components/PopupLoader.svelte";
    import AppHeader from "./lib/components/AppHeader.svelte";
    import Alert from "./lib/components/Alert.svelte";
    import Notifier from "./lib/components/Notifier.svelte";
    import BookTransfer from "./transfer/BookTransfer.svelte";
    import AppFooter from "./lib/components/AppFooter.svelte";
    import ReservationSuccess from "./pages/ReservationSuccess.svelte";
    import ReservationFail from "./pages/ReservationFail.svelte";
    import ReservationDetails from "./pages/ReservationDetails.svelte";
    import NoDepartment from "./pages/NoDepartment.svelte";
    import ReservationCheckout from "./pages/ReservationCheckout.svelte";
    import PageTerms from "./pages/PageTerms.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import Page404 from "./pages/Page404.svelte";
    import MainPage from "./MainPage.svelte";
    import BookOffer from "./offer/BookOffer.svelte";
    import TourDetails from "./lib/components/TourDetails.svelte";


    let appInitialized = false;
    let departmentError = false;
    let reservationError = false;
    let pageNotFound = false;
    let reservation = null;

    const initOffers = (offers) => {
        let list = [];
        let vehicleTypes = copyObject($app.vehicle_types);

        offers.map(offer => {
            offer.vehicles = [];
            offer.vehicle_prices.map(item => {
                let vehicle = copyObject(vehicleTypes.find(x => x.id == item.id));
                if (vehicle) {
                    vehicle.price = item.price;
                    vehicle.start_price = item.start_price;
                    offer.vehicles.push(vehicle);
                }
            });
            list.push(offer);
        });

        $app.offers = list;
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $app.image_url = result.image_url;
            $app.vehicle_types = result.vehicle_types;
            department$.setData(result.dep);
            $location$.list = result.locations;
            initOffers(result.offers);
            appInitialized = true;
        }

        const onFailure = err => {
            appInitialized = true;
            departmentError = true;
        };

        // get department code from url
        const link_code = getDepartmentCode();
        if (link_code === 'not-found') {
            reservationError = true;
            return;
        }
        if (link_code === '404') {
            pageNotFound = true;
            return;
        }

        $app.department_code = link_code

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    $: if (!appInitialized) {
        appInitialize();
    }
</script>

<div id="formTop"></div>
{#if reservationError}
    <NotFound/>
{/if}
{#if pageNotFound}
    <Page404/>
{/if}
{#if appInitialized}
    {#if departmentError}
        <NoDepartment/>
    {:else}
        <PageLoader/>
        <PopupLoader/>
        <AppHeader/>
        <main>
            <div class="app-main-content">
                <Route match="/">
                    <Route match={$department$.link_code}>
                        <Route exact>
                            <MainPage bind:reservation/>
                        </Route>
                        <Route match="book-offer">
                            <BookOffer/>
                        </Route>
                        <Route match="book-transfer">
                            <BookTransfer bind:reservation/>
                        </Route>
                        <Route match="checkout" let:router>
                            <ReservationCheckout hash={router.id}/>
                        </Route>
                        <Route match="reservation" let:router>
                            <ReservationDetails hash={router.id}/>
                        </Route>
                        <Route match="success" let:router>
                            <ReservationSuccess hash={router.id}/>
                        </Route>
                        <Route match="fail" let:router>
                            <ReservationFail hash={router.id}/>
                        </Route>
                        <Route match="terms">
                            <PageTerms/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </main>
        <AppFooter/>
    {/if}
{/if}

{#if $app.tour_id != null}
    <TourDetails tour_id={$app.tour_id} onClose={() => $app.tour_id = null}/>
{/if}

<Alert/>
<Notifier/>